var map = {
	"./img_1.jpg": 17531,
	"./img_10.jpg": 37955,
	"./img_2.jpg": 58554,
	"./img_3.jpg": 92483,
	"./img_4.jpg": 10131,
	"./img_5.jpg": 11887,
	"./img_6.jpg": 49483,
	"./img_7.jpg": 58653,
	"./img_8.jpg": 15763,
	"./img_9.jpg": 7989
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38779;